<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import PushCampaignDetail from '@/modules/push-campaign/views/PushCampaignDetail.vue'
import { Icon } from '@iconify/vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, watch } from 'vue'
import _ from 'lodash'
import {
  PushCampaignListActionTypes,
  usePushCampaignListStore,
} from '@/modules/push-campaign/stores/push-campaign.list.store.ts'

const router = useRouter()
const pushCampaignListStore = usePushCampaignListStore()

const pageTabs = computed(() => {
  return pushCampaignListStore.tabs
})
const displayTabContent = computed(() => {
  return pushCampaignListStore.tabs?.find((tab) => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return pushCampaignListStore.tableConfig
})
const loading = computed(() => {
  return pushCampaignListStore.action_type == PushCampaignListActionTypes.FETCHING
})
const page = computed(() => {
  return pushCampaignListStore.page
})
const pageSize = computed(() => {
  return pushCampaignListStore.pageSize
})
const dataSource = computed(() => {
  return pushCampaignListStore.data
})

const handleChangeTab = (tab: any) => {
  pushCampaignListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {
  pushCampaignListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  pushCampaignListStore.closeAllTab()
}

const handleChangePage = (page: number) => {
  pushCampaignListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {
  pushCampaignListStore.changePageSize(size)
}

const handleSort = (field: string, direction: string) => {
  pushCampaignListStore.toggleSort(field, direction)
}

const requestFetchList = _.debounce(async () => {
  try {
    await pushCampaignListStore.fetchList()
  } catch (e) {}
}, 500)

watch(
  () => pushCampaignListStore.uuid,
  () => {
    requestFetchList()
  },
)

onMounted(() => {
  requestFetchList()
  pushCampaignListStore.changeTab('list')
})
</script>

<template>
  <dashboard-layout
    currentRoute="push-campaign/list"
    page-title="Chiến dịch thông báo đẩy"
    :tabs="pageTabs"
    :tabsEvent="{
      close: handleCloseTab,
      select: handleChangeTab,
      closeAll: handleCloseAllTab,
    }"
  >
    <template v-if="displayTabContent == 'list'">
      <div
        class="flex justify-end mb-4 p-4 bg-white rounded-lg"
        style="
          box-shadow:
            rgba(14, 63, 126, 0.04) 0px 0px 0px 1px,
            rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px,
            rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px;
        "
      >
        <button
          class="table-btn-action btn bg-primary bg-hover-primary text-white"
          @click="
            pushCampaignListStore.newTab({ id: 'create', label: 'Tạo chiến dịch', active: true })
          "
        >
          <Icon icon="gridicons:create" height="18px" />
          Thêm chiến dịch mới
        </button>
      </div>
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        primaryField="id"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="pushCampaignListStore.toggleColumnVisibility"
        @on-sort="handleSort"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <panel :key="tab.id">
            <push-campaign-detail :campaign-id="tab.id === 'create' ? null : tab.id" />
          </panel>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
